import { render, staticRenderFns } from "./ParcelIcon.vue?vue&type=template&id=029a8038"
import script from "./ParcelIcon.vue?vue&type=script&lang=js"
export * from "./ParcelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports